/**
 * File: apps/qbench-cp/reactapp/src/shared/constants/fileUpload.js
 *
 * Purpose: Defines file-type categories and the MIME types/extensions accepted for each.
 *
 * Scope: File upload validation constants used wherever the customer portal accepts image,
 *     spreadsheet, or PDF uploads.
 *
 * Tags: customer-portal
 *
 * Overview: Exports `FileType`, an enum of supported upload categories (IMAGE, XLSX, PDF, ZIP),
 *     and `ValidFileTypes`, a map from each `FileType` to the list of MIME types and file
 *     extensions accepted for that category, including several vendor-specific spreadsheet MIME
 *     types (Excel 2003/2007+, macro-enabled Excel, Apple Numbers).
 *
 * Exports: FileType, ValidFileTypes.
 */

export const FileType = {
	IMAGE: 'IMAGE',
	XLSX: 'XLSX',
	PDF: 'PDF',
	ZIP: 'ZIP',
};

export const ValidFileTypes = {
	[FileType.IMAGE]: [
		'image/jpeg',
		'image/jpg',
		'image/png',
		'image/gif',
		'image/x-icon',
	],
	[FileType.XLSX]: [
		'.csv',
		'.tsv',
		'.xls',
		'.xlsx',
		'text/csv',
		'text/tsv',
		'application/csv',
		'text/comma-separated-values',
		'application/tsv',
		'text/tab-separated-values',
		'application/excel',
		'text/anytext',
		'application/vnd.ms-excel', // Excel 2003 and earlier
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Excel 2007 and later
		'application/vnd.ms-excel.sheet.macroEnabled.12', // Macro-enabled Excel files
		'application/vnd.apple.numbers', // Apple Numbers
		'application/x-iwork-numbers-sffnumbers' // Apple Numbers
	],
	[FileType.PDF]: [
		'application/pdf'
	],
};
